<template>
  <div class="row">
    <div class="col-12">
      <div class="form-group has-label">
        <label>{{ $t('common_words.address') }}</label>
        <br />
        <el-input
          maxlength="200"
          show-word-limit
          class="shadow-sm"
          type="textarea"
          :rows="2"
          placeholder="Carrera XX, vía XXXX, XXXX - Colombia"
          v-model="model.address"
          @change="handleChange('address')"
        ></el-input>
        <br />
      </div>
    </div>
    <select-component
      :dataOptions="countries"
      :isMultiple="false"
      :selectedInitial="model.country"
      @onChange="handleChangeSelected"
      @onClear="model.city = null"
      :labelSelect="`${$t('common_words.country')}: *`"
      modelName="country"
      requireClass="required-second-step"
      rowClass="col-4"
      valueOption="option"
    />
    <select-component
      :dataOptions="states"
      :isMultiple="false"
      :selectedInitial="model.state"
      @onChange="handleChangeSelected"
      :labelSelect="`${$t('common_words.state')}: *`"
      modelName="state"
      requireClass="required-second-step"
      rowClass="col-4"
      valueOption="option"
    />
    <select-component
      :dataOptions="cities"
      :isMultiple="false"
      :selectedInitial="model.city"
      @onChange="handleChangeSelected"
      :labelSelect="`${$t('common_words.city')}: *`"
      modelName="city"
      requireClass="required-second-step"
      rowClass="col-4"
      valueOption="option"
    />
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import optionsAddress from 'src/util/optionsAddress';

export default {
  name: 'select-address',
  data() {
    return {
      model: {
        address: null,
        country: null,
        city: null,
        state: null,
      },
      states: null,
      cities: null,
      countries: null,
    };
  },
  mixins: [MixinPermissions],
  methods: {
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);

      switch (data.name) {
        case 'country':
          this.updateStates();
          this.updateCities();
          this.handleChange('country');
          break;

        case 'state':
          this.updateCities();
          this.handleChange('state');
          break;

        case 'city':
          this.handleChange('city');
          break;

        default:
          break;
      }
    },
    updateStates() {
      this.model.state = null;
      if (this.model.country) {
        this.states = optionsAddress.setStates(this.model.country);
      } else {
        this.states = [];
      }
    },
    updateCities() {
      this.model.city = null;
      if (this.model.country) {
        this.cities = optionsAddress.setCities(
          this.model.country,
          this.model.state
        );
      } else {
        this.cities = [];
      }
    },
    updateCountries() {
      this.model.country = null;
      this.countries = optionsAddress.setCountries(this.model.country);
    },
    handleChange(name) {
      this.$emit('onChange', {
        name,
        selects: this.model[name],
      });
    },
  },
  created() {
    this.$emit('showHideLoading');
    if (!sessionStorage.getItem('editForm')) {
      this.model.country = 'Colombia';
      this.handleChange('country');
      this.updateStates();
    }
    this.countries = optionsAddress.setCountries();
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const { city, state, country, address } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        country,
        address,
      };
      this.updateStates();
      this.model = {
        ...this.model,
        state,
      };
      this.updateCities();
      this.model = {
        ...this.model,
        city,
      };
      this.handleChange('address');
      this.handleChange('country');
      this.handleChange('state');
      this.handleChange('city');
    }
  },
};
</script>
